/* eslint-disable react/no-children-prop */
/* -disable react/style-prop-object */
/* -disable react/no-children-prop */
import React from 'react';
import { FormattedNumber } from 'react-intl';
import moment from 'moment';

import { chartViewUnits } from '../../../../../../../redux/dashboard-completed';

import './styles.css';

// component

function DashboardCompletedChartTooltip({ active, payload }) {
  if (!active || !payload) return null;

  const _data = payload[0].payload;

  const _renderValue = value => {
    switch (_data.viewUnit) {
      case chartViewUnits.WEIGHT:
        return (
          <FormattedNumber
            value={value}
            children={formatted => `${formatted}kg`}
          />
        );

      case chartViewUnits.VALUE:
        return (
          <FormattedNumber value={value} style="currency" currency="BRL" />
        );

      default:
        return <FormattedNumber value={value} />;
    }
  };

  const _renderPc = pcValue => (
    <FormattedNumber
      value={pcValue}
      style="percent"
      minimumFractionDigits={2}
      maximumFractionDigits={2}
    />
  );

  return (
    <div className="DashboardCompletedChartTooltip">
      <h1 className="DashboardCompletedChartTooltip__label">
        {moment(_data.date).format('DD/MM/YYYY')}
      </h1>
      <p className="DashboardCompletedChartTooltip__total">
        Total: {_renderValue(_data.totalValue)}
      </p>
      <p className="DashboardCompletedChartTooltip__on-time">
        No prazo: {_renderValue(_data.onTimeValue)} (
        {_renderPc(_data.onTimeValuePc)})
      </p>
      <p className="DashboardCompletedChartTooltip__late">
        Atrasado: {_renderValue(_data.lateValue)} (
        {_renderPc(_data.lateValuePc)})
      </p>
    </div>
  );
}

export default DashboardCompletedChartTooltip;
